// import React from 'react';
// import { motion } from 'motion/react';
// import { useInView } from 'react-intersection-observer';
// import { MessageSquare, LogIn, Edit3, Share2 } from 'lucide-react';

// const steps = [
//   {
//     number: 1,
//     title: 'Contact Us',
//     description: 'Reach out to our team to get started',
//     icon: MessageSquare,
//     color: 'from-blue-500 to-cyan-500',
//   },
//   {
//     number: 2,
//     title: 'Log In',
//     description: 'Access your personalized dashboard',
//     icon: LogIn,
//     color: 'from-purple-500 to-pink-500',
//   },
//   {
//     number: 3,
//     title: 'Update Anytime',
//     description: 'Edit your card details in real-time',
//     icon: Edit3,
//     color: 'from-orange-500 to-red-500',
//   },
//   {
//     number: 4,
//     title: 'Share Easily',
//     description: 'Share via NFC, QR code, or link',
//     icon: Share2,
//     color: 'from-green-500 to-emerald-500',
//   },
// ];

// export function HowItWorks() {
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.1,
//   });

//   return (
//     <section className="py-20 lg:py-32 px-4 sm:px-6 lg:px-20 relative overflow-hidden">
//       <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/5 to-transparent dark:via-primary/10" />

//       <div className="max-w-6xl mx-auto relative">
//         <motion.div
//           ref={ref}
//           initial={{ opacity: 0, y: 30 }}
//           animate={inView ? { opacity: 1, y: 0 } : {}}
//           transition={{ duration: 0.6 }}
//           className="text-center mb-16"
//         >
//           <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
//             How It{' '}
//             <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
//               Works
//             </span>
//           </h2>
//           <p className="text-lg text-muted-foreground">
//             Getting your Virtual Business Card is simple
//           </p>
//         </motion.div>

//         {/* Desktop Timeline */}
//         <div className="hidden lg:block relative">
//           {/* Timeline Line */}
//           <div className="absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-primary via-accent to-secondary" />

//           <div className="grid grid-cols-4 gap-8">
//             {steps.map((step, index) => (
//               <motion.div
//                 key={step.number}
//                 initial={{ opacity: 0, y: 50 }}
//                 animate={inView ? { opacity: 1, y: 0 } : {}}
//                 transition={{ delay: index * 0.15, duration: 0.6 }}
//                 className="relative"
//               >
//                 {/* Number Circle */}
//                 <motion.div
//                   className={`w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br ${step.color} flex items-center justify-center shadow-lg relative z-10`}
//                   whileHover={{ scale: 1.1, rotate: 5 }}
//                   transition={{ type: 'spring', stiffness: 300 }}
//                 >
//                   <span className="text-2xl font-bold text-white">{step.number}</span>
//                 </motion.div>

//                 {/* Card */}
//                 <motion.div
//                   whileHover={{ y: -8 }}
//                   className="bg-card border border-border rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300"
//                 >
//                   <step.icon className={`w-10 h-10 mb-4 mx-auto text-transparent bg-gradient-to-br ${step.color} bg-clip-text`} style={{ WebkitTextFillColor: 'transparent', WebkitBackgroundClip: 'text' }} />
//                   <h3 className="text-xl font-bold text-foreground mb-2 text-center">
//                     {step.title}
//                   </h3>
//                   <p className="text-muted-foreground text-center text-sm">
//                     {step.description}
//                   </p>
//                 </motion.div>
//               </motion.div>
//             ))}
//           </div>
//         </div>

//         {/* Mobile Timeline */}
//         <div className="lg:hidden space-y-8">
//           {steps.map((step, index) => (
//             <motion.div
//               key={step.number}
//               initial={{ opacity: 0, x: -50 }}
//               animate={inView ? { opacity: 1, x: 0 } : {}}
//               transition={{ delay: index * 0.15, duration: 0.6 }}
//               className="relative flex gap-6"
//             >
//               {/* Vertical Line */}
//               {index < steps.length - 1 && (
//                 <div className="absolute left-10 top-20 bottom-0 w-1 bg-gradient-to-b from-primary to-accent translate-x-[-50%]" />
//               )}

//               {/* Number Circle */}
//               <motion.div
//                 className={`w-20 h-20 flex-shrink-0 rounded-full bg-gradient-to-br ${step.color} flex items-center justify-center shadow-lg relative z-10`}
//                 whileHover={{ scale: 1.1, rotate: 5 }}
//               >
//                 <span className="text-2xl font-bold text-white">{step.number}</span>
//               </motion.div>

//               {/* Card */}
//               <motion.div
//                 whileHover={{ x: 8 }}
//                 className="flex-1 bg-card border border-border rounded-2xl p-6 shadow-lg"
//               >
//                 <step.icon className="w-10 h-10 mb-3" style={{ 
//                   stroke: 'url(#gradient)',
//                 }} />
//                 <svg width="0" height="0">
//                   <defs>
//                     <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
//                       <stop offset="0%" stopColor="#4F46E5" />
//                       <stop offset="100%" stopColor="#06B6D4" />
//                     </linearGradient>
//                   </defs>
//                 </svg>
//                 <h3 className="text-xl font-bold text-foreground mb-2">
//                   {step.title}
//                 </h3>
//                 <p className="text-muted-foreground">
//                   {step.description}
//                 </p>
//               </motion.div>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }



import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { MessageSquare, LogIn, Edit3, Share2 } from 'lucide-react';

const steps = [
  { number: 1, title: 'Contact Us', description: 'Reach out to our team to get started', icon: MessageSquare, gradient: ['#3b82f6', '#06b6d4'] },
  { number: 2, title: 'Log In', description: 'Access your personalized dashboard', icon: LogIn, gradient: ['#8b5cf6', '#ec4899'] },
  { number: 3, title: 'Update Anytime', description: 'Edit your card details in real-time', icon: Edit3, gradient: ['#f97316', '#ef4444'] },
  { number: 4, title: 'Share Easily', description: 'Share via NFC, QR code, or link', icon: Share2, gradient: ['#10b981', '#22c55e'] },
];

const HowItWorks = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section
      ref={ref}
      style={{
        position: 'relative',
        padding: '80px 16px',
        overflow: 'hidden',
        background: 'linear-gradient(to bottom, rgba(139,92,246,0.05), transparent)',
      }}
    >
      {/* Heading */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
        style={{ textAlign: 'center', marginBottom: '64px' }}
      >
        <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '16px', lineHeight: 1.2 }}>
          How It{' '}
          <span style={{ background: 'linear-gradient(to right, #8b5cf6, #fbbf24)', WebkitBackgroundClip: 'text', color: 'transparent' }}>
            Works
          </span>
        </h2>
        <p style={{ fontSize: '1.125rem', color: '#888888' }}>Getting your Virtual Business Card is simple</p>
      </motion.div>

      {isMobile ? (
        // MOBILE VERSION - FULL WIDTH
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '32px' }}>
          {steps.map((step) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={step.number}
                initial={{ opacity: 0, x: -50 }}
                animate={inView ? { opacity: 1, x: 0 } : {}}
                transition={{ delay: step.number * 0.15, duration: 0.6 }}
                style={{ display: 'flex', alignItems: 'flex-start', gap: '16px', marginBottom: '32px' }}
              >
                {/* Number */}
                <motion.div
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: `linear-gradient(to bottom right, ${step.gradient[0]}, ${step.gradient[1]})`,
                    color: 'white',
                    fontWeight: '700',
                    fontSize: '1.25rem',
                    flexShrink: 0,
                  }}
                >
                  {step.number}
                </motion.div>

                {/* Card */}
                <motion.div
                  whileHover={{ x: 8 }}
                  style={{
                    flex: 1,
                    padding: '20px',
                    borderRadius: '24px',
                    background: '#fff',
                    boxShadow: '0 8px 16px rgba(0,0,0,0.05)',
                    border: '1px solid #e5e7eb',
                  }}
                >
                  <Icon
                    style={{
                      width: '32px',
                      height: '32px',
                      marginBottom: '12px',
                      background: `linear-gradient(to bottom right, ${step.gradient[0]}, ${step.gradient[1]})`,
                      WebkitBackgroundClip: 'text',
                      color: 'transparent',
                    }}
                  />
                  <h3 style={{ fontSize: '1.125rem', fontWeight: '700', marginBottom: '4px' }}>{step.title}</h3>
                  <p style={{ fontSize: '0.875rem', color: '#888888' }}>{step.description}</p>
                </motion.div>
              </motion.div>
            );
          })}
        </div>
      ) : (
        // DESKTOP VERSION - CENTERED WITH MAX WIDTH
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '32px' }}>
          {steps.map((step) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={step.number}
                initial={{ opacity: 0, y: 50 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ delay: step.number * 0.15, duration: 0.6 }}
                style={{ position: 'relative' }}
              >
                <motion.div
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    margin: '0 auto 24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: `linear-gradient(to bottom right, ${step.gradient[0]}, ${step.gradient[1]})`,
                    color: 'white',
                    fontWeight: '700',
                    fontSize: '1.5rem',
                    zIndex: 10,
                    position: 'relative',
                  }}
                >
                  {step.number}
                </motion.div>
                <motion.div
                  whileHover={{ y: -8 }}
                  style={{
                    padding: '24px',
                    borderRadius: '24px',
                    background: '#fff',
                    boxShadow: '0 10px 20px rgba(0,0,0,0.05)',
                    textAlign: 'center',
                    border: '1px solid #e5e7eb',
                  }}
                >
                  <Icon
                    style={{
                      width: '40px',
                      height: '40px',
                      marginBottom: '16px',
                      background: `linear-gradient(to bottom right, ${step.gradient[0]}, ${step.gradient[1]})`,
                      WebkitBackgroundClip: 'text',
                      color: 'transparent',
                    }}
                  />
                  <h3 style={{ fontSize: '1.25rem', fontWeight: '700', marginBottom: '8px' }}>{step.title}</h3>
                  <p style={{ fontSize: '0.875rem', color: '#888888' }}>{step.description}</p>
                </motion.div>
              </motion.div>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default HowItWorks;

